import loadScript from '@/utils/load-script';
import '../../public/libs/authority/authority.css';

export default async function () {
    if (!window.jQuery) await loadScript('/libs/jquery/2.2.2/jquery.min.js')
    await loadScript('/libs/authority/authority.js')
}
